import React from 'react';
import { Box } from '@material-ui/core';
import { getEnvVariable } from '../../../modules/environmentalList';

function AdvancedSearchPage() {

    return (
        <Box style={{ height: '100%', width: '100%' }}>
            <iframe src={getEnvVariable('AdvSearchUIURL')} title="Advanced Search" width="100%" height={window.innerHeight - 50}></iframe>
        </Box>
    );
}

export default AdvancedSearchPage;